import React from "react";
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Feature from './feature'
import '../assets/css/main.css'

class ServiceFeatures extends React.Component {        
  render() {    
    var posts = this.props.posts;
    // posts.map(function ({ node }) {
    //     console.log(node.title);
    //     console.log(node.heroImage.fluid);

    // });
     
    return (
      <React.Fragment>
        <div className="page_wrapper">            
            <ul className="article-list">
                {posts.map(function ({ node }) {
                    return (
                        <li key={node.slug}>
                            <Feature feature={node} />
                        </li>
                        )
                    })}
            </ul>
        </div>
      </React.Fragment>
    )
  }
}


export default ServiceFeatures;

